<template>
  <div class="ProductCard">
    <router-link :to='"/tour/" + tour.id'>
      <div class="product_card">
        <div class="imgbox">
          <b-img class="card_img"
            :src="'https://tstar888.com/JP2TW/test/vue_jp2tw/src/assets/imageData/' + tour.cover + '.jpg'"
            :alt="tour.name"
            onerror="javascript:this.src='https://tstar888.com/tours/img/pexels-dominika-roseclay-12525002.d4e02731.jpg';this.onerror = null"></b-img>
        </div>
        <b-badge class="badge_tag" v-if="tour.saleTag !== '無'">{{ tour.saleTag }}</b-badge>
        <b-badge class="badge_departureTag" v-if="tour.departureTag !== '無'">{{ tour.departureTag }}</b-badge>
        <div class="px-2 px-sm-3 pb-3">
          <div class="title">{{ tour.title }}</div>
          <div class="days">
            <b-icon-clock-fill class="fa-fw mr-2"></b-icon-clock-fill>
            <span class="product_days">{{ tour.days }}天</span>
          </div>
          <div class="price mt-2" v-if="tour.normalPrice !== '0'">
            <b-icon-currency-dollar class="fa-fw mr-2"></b-icon-currency-dollar>
            <span class="product_price">{{ tour.normalPrice }}</span> 起
          </div>

          <!-- GO -->
          <div v-if="tour.registration_info.status"
            class="mt-2 d-md-flex justify-content-md-state align-items-center flex-wrap">
            <b-col cols="12" md="4" class="mb-1 text_date" v-for="(items, index) in filteredItems" :key="index">
              <div class="pb-1 text-center text-secondary ">
                <div>{{ items.order1 }}</div>
                <div>
                  <span class="text-danger">尚可報名</span>
                </div>
              </div>
            </b-col>
          </div>

        </div>

      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    tour: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      tours: this.tour.registration_info.data[0]
    }
  },
  computed: {
    filteredItems() {
      const today = new Date() // 取得當前日期
      return this.tours.dynamicFields
        ? this.tours.dynamicFields
          .filter((items) => {
            const itemDate = new Date(items.order1) // 將 items.order1 轉為日期物件
            return itemDate >= today // 過濾出未過期的日期
          })
          .slice(0, 6) // 取前 6 個項目
        : []
    }
  }

}
</script>

<style lang="scss">
.ProductCard {
  & * {
    transition: .3s;
  }

  a {
    color: #3c404b;

    &:hover {
      color: #3c404b;

      & .title {
        color: var(--mytext) !important;
      }
    }
  }

  .product_card {
    &:hover {
      transform: translateY(-3px);
    }

    background-color: #fff;
    position: relative;
    border-radius: 10px;
    box-shadow: var(--shadow);
    text-align: left;
    margin-bottom: 1rem;
    font-size: 15px;

    .title {
      // height: 48px;
      font-weight: 500;
      font-size: .95rem;
      // letter-spacing: .5px;
      margin-bottom: 8px;
      transition: 0.3s;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }

    a:hover .card_img {
      transform: scale(1.03);
    }

    .badge_tag {
      padding: .3rem .4rem;
      font-size: .9rem;
      background-color: var(--myred);
      position: absolute;
      // bottom: 5px;
      top: -5px;
      // left: -3px;
      right: -5px;
      // right: 50%;
      // transform: translateX(50%);
      letter-spacing: 1.5px;
      box-shadow: -3px 3px 3px rgba(0, 0, 0, 0.25);
      font-weight: 500;
    }

    .badge_departureTag {
      padding: .3rem .4rem;
      font-size: .9rem;
      background-color: var(--green_title);
      position: absolute;
      // bottom: 5px;
      top: 25px;
      // left: -3px;
      right: -5px;
      // right: 50%;
      // transform: translateX(50%);
      letter-spacing: 1.5px;
      box-shadow: -3px 3px 3px rgba(0, 0, 0, 0.25);
      font-weight: 500;
    }

    .text_date {
      background-color: #e7e7e7;
      border-radius: 10px;
      font-size: 14px;
      text-align: center;
    }

    .text_date:hover {
      background-color: #cccccc;
    }
  }

  .imgbox {
    // border-bottom: 1px solid #d1d1d1;
    border-radius: 10px 10px 0 0;
    overflow: hidden;
    position: relative;
    width: 100%;
    padding-top: 56.25%;
    margin-bottom: 10px;

    img {
      position: absolute;
      object-fit: cover;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  @media (min-width:768px) {
    .product_card .title {
      font-size: 1rem;
    }
  }
}
</style>
